/**
 * year-slider.js — Replaces the Year metafield checkbox filter with a range slider.
 * Re-runs after every AJAX filter refresh so it survives other filter changes.
 */
(function () {
  function enhance(details) {
    if (details.dataset.yearSliderEnhanced) return;
    const summaryText = (details.querySelector('summary')?.innerText || '').toLowerCase();
    if (!summaryText.includes('year')) return;

    const checkboxes = Array.from(details.querySelectorAll('input[type="checkbox"]'));
    if (!checkboxes.length) return;

    const years = checkboxes
      .map((cb) => parseInt((cb.value || '').match(/(\d{4})/)?.[1] || '', 10))
      .filter((y) => Number.isFinite(y));
    if (years.length < 2) return;

    const minYear = Math.min(...years);
    const maxYear = Math.max(...years);
    const selectedYears = checkboxes.filter((c) => c.checked).map((c) => parseInt(c.value, 10)).filter(Number.isFinite);
    const currentMin = selectedYears.length ? Math.min(...selectedYears) : minYear;
    const currentMax = selectedYears.length ? Math.max(...selectedYears) : maxYear;

    details.dataset.yearSliderEnhanced = '1';

    const listContainer = details.querySelector('.facets__list, ul, .facets__display');
    if (!listContainer) return;

    const labelStyle = "color: rgb(var(--color-foreground)); font-size: 1.4rem;";
    const slider = document.createElement('div');
    slider.className = 'year-slider-wrap';
    slider.innerHTML = `
      <div class="year-slider-values" style="display:flex; justify-content: space-between; ${labelStyle} margin-bottom: 1.6rem;">
        <span class="year-slider-from">${currentMin}</span>
        <span class="year-slider-to">${currentMax}</span>
      </div>
      <div class="year-slider-track" style="position: relative; height: 28px;">
        <div class="year-slider-rail" style="position:absolute; top:50%; transform:translateY(-50%); left:0; right:0; height:3px; background: rgba(var(--color-foreground), 0.2); border-radius: 2px;"></div>
        <div class="year-slider-range" style="position:absolute; top:50%; transform:translateY(-50%); height:3px; background: rgb(var(--color-accent)); border-radius: 2px;"></div>
        <input class="year-slider-input year-slider-min" type="range" min="${minYear}" max="${maxYear}" value="${currentMin}" step="1"
               style="position:absolute; inset:0; width:100%; -webkit-appearance:none; appearance:none; background:transparent; pointer-events:none; z-index:2;">
        <input class="year-slider-input year-slider-max" type="range" min="${minYear}" max="${maxYear}" value="${currentMax}" step="1"
               style="position:absolute; inset:0; width:100%; -webkit-appearance:none; appearance:none; background:transparent; pointer-events:none; z-index:3;">
      </div>
    `;

    if (!document.getElementById('year-slider-style')) {
      const s = document.createElement('style');
      s.id = 'year-slider-style';
      s.textContent = `
        .year-slider-input::-webkit-slider-thumb {
          -webkit-appearance: none; appearance: none;
          width: 18px; height: 18px; border-radius: 50%;
          background: rgb(var(--color-accent));
          border: 2px solid rgb(var(--color-background));
          cursor: pointer; pointer-events: auto;
          box-shadow: 0 0 0 1px rgb(var(--color-accent));
        }
        .year-slider-input::-moz-range-thumb {
          width: 18px; height: 18px; border-radius: 50%;
          background: rgb(var(--color-accent));
          border: 2px solid rgb(var(--color-background));
          cursor: pointer; pointer-events: auto;
          box-shadow: 0 0 0 1px rgb(var(--color-accent));
        }
        .year-slider-input::-webkit-slider-runnable-track { background: transparent; }
        .year-slider-input::-moz-range-track { background: transparent; }
        .year-slider-wrap { padding: 1rem 0 2rem; }
      `;
      document.head.appendChild(s);
    }

    const checkboxesContainer = document.createElement('div');
    checkboxesContainer.style.display = 'none';
    checkboxesContainer.className = 'year-slider-hidden-checkboxes';
    checkboxes.forEach((cb) => checkboxesContainer.appendChild(cb));

    listContainer.innerHTML = '';
    listContainer.appendChild(slider);
    listContainer.appendChild(checkboxesContainer);

    const minInp = slider.querySelector('.year-slider-min');
    const maxInp = slider.querySelector('.year-slider-max');
    const fromLbl = slider.querySelector('.year-slider-from');
    const toLbl = slider.querySelector('.year-slider-to');
    const rangeBar = slider.querySelector('.year-slider-range');

    function paintRange() {
      const a = parseInt(minInp.value, 10);
      const b = parseInt(maxInp.value, 10);
      const lo = Math.min(a, b);
      const hi = Math.max(a, b);
      const span = maxYear - minYear || 1;
      const left = ((lo - minYear) / span) * 100;
      const right = 100 - ((hi - minYear) / span) * 100;
      rangeBar.style.left = left + '%';
      rangeBar.style.right = right + '%';
      fromLbl.textContent = lo;
      toLbl.textContent = hi;
    }
    paintRange();

    function syncCheckboxes() {
      const a = parseInt(minInp.value, 10);
      const b = parseInt(maxInp.value, 10);
      const lo = Math.min(a, b);
      const hi = Math.max(a, b);
      let changedCb = null;
      checkboxes.forEach((cb) => {
        const y = parseInt(cb.value, 10);
        const shouldCheck = y >= lo && y <= hi;
        if (cb.checked !== shouldCheck) {
          cb.checked = shouldCheck;
          changedCb = cb;
        }
      });
      return changedCb;
    }

    function fireFilter() {
      const changed = syncCheckboxes();
      if (!changed) return;
      // Fire a single change event on one of the changed checkboxes.
      // Force theme's facets-form listens for change events on inputs inside the form
      // and triggers an AJAX section refresh, which avoids a full page reload.
      const evt = new Event('change', { bubbles: true, cancelable: true });
      changed.dispatchEvent(evt);
    }

    let dragTimer = null;
    function onInput() {
      paintRange();
      clearTimeout(dragTimer);
      dragTimer = setTimeout(fireFilter, 450);
    }
    minInp.addEventListener('input', onInput);
    maxInp.addEventListener('input', onInput);
    minInp.addEventListener('change', () => { paintRange(); clearTimeout(dragTimer); fireFilter(); });
    maxInp.addEventListener('change', () => { paintRange(); clearTimeout(dragTimer); fireFilter(); });
  }

  function enhanceAll() {
    document.querySelectorAll('details.js-filter, details.facets__disclosure').forEach(enhance);
  }

  function observe() {
    // Re-apply enhancement when Shopify swaps the filter sidebar after any AJAX refresh.
    const candidates = document.querySelectorAll('facet-filters-form, #FacetsWrapperDesktop, .facets-wrapper, [data-section-type*="collection"]');
    const observer = new MutationObserver(() => {
      // Reset the per-details flag so we re-enhance on the newly-rendered DOM.
      document.querySelectorAll('details[data-year-slider-enhanced]').forEach((d) => {
        if (!d.querySelector('.year-slider-wrap')) {
          delete d.dataset.yearSliderEnhanced;
        }
      });
      enhanceAll();
    });
    const targets = candidates.length ? candidates : [document.body];
    targets.forEach((t) => observer.observe(t, { childList: true, subtree: true }));
  }

  function init() {
    enhanceAll();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', enhanceAll);
})();
